export default function detection (agent) {
  return true;
}



// WEBPACK FOOTER //
// ./src/devices/workstation/detection.js